import SimpleSearchInput from './SimpleSearchInput';

export default SimpleSearchInput;
